module.exports = __webpack_public_path__ + "img/ProductLineProgress.bb63dfa1.jpg";